import React from "react"
import Img from "gatsby-image"
import {Button} from "@material-ui/core"
import {useStaticQuery} from 'gatsby'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Container from 'react-bootstrap/Container'

import LayoutStyle from "../components/layout"
import SEO from "../components/seo"
import './index.style.css'


import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const IndexPage = () => {

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "kasko_mascot2.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)


  return(
    <LayoutStyle>
      <SEO
        title="Kasko.no | Forsikring. Sammenlignet."
        description="Sammenlign tilbud på forsikring på Kasko.no. Det er store forskjeller på forsikringsselskapene. Velg riktig forsikring: Kasko, Delkasko og Ansvarsforsikring."/>

      <Jumbotron>
        <Container style={{textAlign:'center'}}>
          <h1>Betaler du for mye for forsikringene dine?</h1>
          {/*<h4>
            Kasko gjør noen tekniske oppgraderinger - og er snart tilbake!
          </h4>*/}

          <div className="frontPageBox">
            <div className="frontPageChar"><Img fluid={data.file.childImageSharp.fluid}/></div>
            <div className="frontPageWIP">
              <FontAwesomeIcon icon={faExclamationTriangle} size={"4x"}/><br/>
              {/*Arbeid pågår*/}
              Vi gjør noen tekniske oppgraderinger - og er snart tilbake!
            </div>
          </div>
        </Container>
      </Jumbotron>

    </LayoutStyle>
  )
}

export default IndexPage


